<template>
  <v-card class="elevation-12 mt-3 mx-1" :loading="loading">
    <v-toolbar color="primary" dark flat>
      {{ pageTitle }}
      <v-spacer/>
      <v-btn color="success" small @click="onPrintAndCloseButtonClicked">Распечатать и выйти</v-btn>
    </v-toolbar>

    <template v-if="isPostPackageLoaded">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" lg="3">
            <v-text-field v-model="mailUid"
                          label="Идентификатор письма"
                          @keyup.enter="onMailUidKepUpEnter"
                          ref="mailUid"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th>№</th>
              <th>Идентификатор</th>
              <th>Получатель</th>
              <th>Область</th>
              <th>Район</th>
              <th>Адрес</th>
              <th>Дата поступления</th>
              <th>Печатный пакет</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="mail in displayMails" :key="mail.id"
                :class="{'black': mail.isPerformedNotTry, 'white--text': mail.isPerformed}">
              <td>{{ mail.displayNumber }}</td>
              <td>
                {{ mail.uid }}
              </td>
              <td>{{ mail.receiver }}</td>
              <td>{{ mail.region.name }}</td>
              <td>{{ mail.area.name }}</td>
              <td>{{ mail.address }}</td>
              <td class="text-center">
                {{ mail.createdOn.format('DD.MM.YYYY') }}
                <br>
                {{ mail.createdOn.format('HH:mm:ss') }}
              </td>
              <td>
                {{ mail.printPackage.uid }}
              </td>
              <td>
                <v-btn v-if="isAllowUnsetPostPackageMail" small color="error"
                       @click="deleteMail = mail; deleteDialog = true">Удалить
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </template>

    <v-card-actions>
      <v-spacer/>
      <span>Писем: {{ mailsCount }}</span>
      <span class="ml-3">Листов: {{ mailsPagesSum }}</span>
      <v-spacer/>
    </v-card-actions>

    <v-dialog v-model="deleteDialog" max-width="600px">
      <v-card :loading="loading">
        <v-card-title class="headline">
          Вы действительн хотите удалить письмо из пост-пакета?
        </v-card-title>

        <v-card-text>
          В случае удаления, письмо нужно будет посадить в пост-пакет заново
        </v-card-text>

        <v-card-actions>
          <v-btn color="default" text @click="deleteMail = null; deleteDialog = false" :disabled="loading">
            Закрыть
          </v-btn>
          <v-spacer/>
          <v-btn color="error" text dark @click="onDeleteConfirmClicked" :disabled="loading">Да, удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="deleteMailFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось удалить письмо из пост-пакета
    </v-snackbar>
    <v-snackbar v-model="setMailPostPackageFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось добавить письмо в пост-пакета
    </v-snackbar>
    <v-snackbar v-model="maximumLimitReachedPerPackageSnackbar"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Больше добавить в пост-пакет писем не получится. Есть ограничение на максимальное количество писем в пакете
      {{ maxMailsPerPackageLimit }}
    </v-snackbar>
  </v-card>
</template>

<script>
import _ from "underscore";
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import PostPackageService from "@/services/post.package.service";
import Mappers from "@/mappers";
import PrintJS from "print-js";
import {required} from 'vuelidate/lib/validators'
import MailService from '@/services/mail.service'
import {
  AllowCreatePostPackage,
  AllowUnsetMailPostPackage
} from "@/enums/permission";
import {MailPostIndexClients, MailPostIndexRegions} from "@/helpers/constants";

export default {
  name: "PostPackageSetMailsView",
  data() {
    return {
      // datatable
      postPackage: null,
      mails: [],
      loading: false,

      maxMailsPerPackageLimit: 50,

      mailUid: '',

      deleteMail: null,
      deleteDialog: false,

      setMailPostPackageFailed: false,
      deleteMailFailed: false,

      maximumLimitReachedPerPackageSnackbar: false
    }
  },
  validations: {
    mailUid: {
      required
    }
  },
  computed: {
    pageTitle() {
      let title = 'Формирование пост пакета'
      if (this.postPackage) {
        title = `${title} : ${this.postPackage.uid} - ${this.postPackage.postCode}`
        if (this.postPackage.postIndex)
          title = `${title} - ${this.postPackage.postIndex.name}`
      }

      return title
    },
    isPostPackageLoaded() {
      return !!this.postPackage
    },
    mailsCount() {
      return this.mails.length
    },
    mailsPagesSum() {
      let sum = 0
      _.each(this.mails, m => {
        sum += m.pagesCount
      })

      return sum
    },
    displayMails() {
      let number = this.mails.length;
      return _.map(this.mails, m => {
        m.displayNumber = number--

        return m
      })
    },
    isAllowAddingPostIndex(){
      return MailPostIndexClients.includes(this.$store.getters.appActiveClient) && MailPostIndexRegions.includes(this.postPackage.region?.id);
    },
    isAllowPostPackageCreate() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePostPackage
      })
    },

    isAllowUnsetPostPackageMail() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowUnsetMailPostPackage
      })
    },
  },
  methods: {
    loadPostPackage() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      this.postPackage = null
      const uid = this.$route.params.uid

      PostPackageService.get(uid)
          .then(response => {
            this.postPackage = Mappers.mapPostPackage(response.data)
            this.setPageTitle()

            this.loadMails()

            this.$nextTick(() => {
              this.$refs.mailUid.focus()
            })
          })
          .catch(() => {
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadMails() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      PostPackageService.getMails(this.postPackage.uid)
          .then(response => {
            this.mails = _.map(response.data, mailViewModel => {
              return Mappers.mapMail(mailViewModel)
            })
          })
          .catch(() => {
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    setPageTitle() {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.pageTitle)
    },

    onPrintAndCloseButtonClicked() {
      const path = PostPackageService.getPdfPath(this.postPackage)

      PrintJS({
        printable: path,
        type: 'pdf',
        showModal: true,
        modalMessage: 'Подождите, идет загрузка для печати'
      })

      this.$router.push({name: 'post-packages'})
    },
    onMailUidKepUpEnter() {
      this.$v.$touch()
      this.mailUid = this.mailUid.trim()

      if (this.mails.length >= this.maxMailsPerPackageLimit) {
        this.maximumLimitReachedPerPackageSnackbar = true
        return;
      }


      if (!this.$v.$invalid) {
        this.loading = true
        this.$store.dispatch(LAYOUT_LOADING_START)

        this.setMailPostPackageFailed = false

        MailService.setPostPackage({postPackage: this.postPackage, mailUid: this.mailUid})
            .then(() => {
              this.loadMails()
            }, () => {
              this.setMailPostPackageFailed = true
            })
            .catch(() => {
              this.setMailPostPackageFailed = true
            })
            .finally(() => {
              this.loading = false
              this.$store.dispatch(LAYOUT_LOADING_STOP)

              this.mailUid = ''
            })
      } else {
        this.mailUid = ''
      }
    },
    onDeleteConfirmClicked() {
      this.loading = true
      this.$store.dispatch(LAYOUT_LOADING_START)

      this.deleteMailFailed = false
      MailService.deleteFromPostPackage(this.deleteMail)
          .then(() => {
            this.deleteDialog = false
            this.deleteMail = null

            this.loadMails()
          }, () => {
            this.deleteMailFailed = true
          })
          .catch(() => {
            this.deleteMailFailed = true
          })
          .finally(() => {
            this.loading = false
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowPostPackageCreate) {
      this.setPageTitle()
      this.loadPostPackage()
    } else {
      this.$router.go(-1)
    }
  },
  watch: {
    "$route": function () {
      this.loadPostPackage()
    }
  },
}
</script>

<style scoped>

</style>

